import { Actor, Collider, CollisionContact, Color, Engine, Side, vec } from 'excalibur';
import { Brick } from './brick';
import { bricks } from './bricks';
export class Ball extends Actor {
    private readonly radius: number;
    constructor() {
        super({
            name: 'ball',
            x: 500,
            y: 800,
            radius: 30,
            color: Color.Red,
        });
        this.radius = 30;
    }

    private _ballspeed = vec(1000, -1000);
    override onInitialize() {
        this.vel = this._ballspeed;
    }

    override onPreUpdate(engine: Engine, elapsedMs: number): void {
        // Put any update logic here runs every frame before Actor builtins
    }

    override onPostUpdate(engine: Engine, elapsedMs: number): void {
        // Left edge
        if (this.pos.x - this.radius < 0) {
            this.pos.x = this.radius;
            this.vel.x = Math.abs(this._ballspeed.x);
        }
        // Right edge
        if (this.pos.x + this.radius > engine.drawWidth) {
            this.pos.x = engine.drawWidth - this.radius;
            this.vel.x = -Math.abs(this._ballspeed.x);
        }
        // Top edge (strict clamp)
        if (this.pos.y - this.radius < 0) {
            this.pos.y = this.radius;
            this.vel.y = Math.abs(Math.abs(this._ballspeed.y)); // always positive, force downward
            if (this.vel.y < 50) this.vel.y = 50; // minimum downward speed
        }
        // Bottom edge (optional: you may want to handle "game over" here)
        if (this.pos.y + this.radius > engine.drawHeight) {
            this.kill();
            if ('reset' in engine.currentScene && typeof engine.currentScene.reset === 'function') engine.currentScene.reset();
        }
    }

    override onPreCollisionResolve(self: Collider, other: Collider, side: Side, contact: CollisionContact): void {
        // Called before a collision is resolved, if you want to opt out of this specific collision call contact.cancel()
    }

    override onPostCollisionResolve(self: Collider, other: Collider, side: Side, contact: CollisionContact): void {
        // Called every time a collision is resolved and overlap is solved
    }

    private _colliding = false;
    override onCollisionStart(self: Collider, other: Collider, side: Side, contact: CollisionContact): void {
        if (other.owner.name === 'brick' && bricks.indexOf(other.owner as Brick) > -1) other.owner.kill();

        var intersection = contact.mtv.normalize();

        if (!this._colliding) {
            this._colliding = true;

            if (Math.abs(intersection.x) > Math.abs(intersection.y)) {
                this.vel.x *= -1;
            } else {
                this.vel.y *= -1;
            }
        }
    }

    override onCollisionEnd(self: Collider, other: Collider, side: Side, lastContact: CollisionContact): void {
        this._colliding = false;
    }
}
